import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDStatus } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface ChangeTsdStatusParams {
  tsdId: string;
  status: TSDStatus;
}

export const useChangeTsdStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ tsdId, status }: ChangeTsdStatusParams) => {
      const result = await apiClient.adminTsd.updateTsdStatus.mutation({
        params: {
          tsdId,
        },
        body: {
          status,
        },
      });

      if (result.status !== 200) {
        throw result.body;
      }

      return result.body;
    },
    onSuccess: () => {
      toast.success('TSD status updated!');
      queryClient.invalidateQueries({ queryKey: ['admin-temporary-storages'] });
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating TSD status!');
    },
  });
};
